import { render, staticRenderFns } from "./editPop.vue?vue&type=template&id=54ae6c40&scoped=true&"
import script from "./editPop.vue?vue&type=script&lang=js&"
export * from "./editPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae6c40",
  null
  
)

export default component.exports